import type { LayoutTokenClasses } from '../ModularTypes/LayoutSettings';

type ClassValue = string | undefined | null;

export class LayoutClassBuilder {
  static build(props: LayoutTokenClasses): string {
    const {
      className,
      layout,
      gridTemplate,
      flexDirection,
      gap,
      justifyContent,
      justifyItems,
      alignContent,
      alignItems,
      background,
      padding,
    } = props;

    return [
      'layout-root',
      className,
      layout,

      this.prefixed('grid-template', gridTemplate),
      this.prefixed('flex-direction', flexDirection),
      this.prefixed('gap', gap),
      this.prefixed('bg', background),
      this.prefixed('padding', padding),

      this.prefixed('justify-content', justifyContent),
      this.prefixed('justify-items', justifyItems),
      this.prefixed('align-content', alignContent),
      this.prefixed('align-items', alignItems),
    ]
      .filter(this.isValid)
      .join(' ');
  }

  static isValid(value: ClassValue): value is string {
    return typeof value === 'string' && value.trim() !== '';
  }

  static prefixed(prefix: string, value: ClassValue): string | null {
    return value ? `${prefix}-${value}` : null;
  }
}
